// extracted by mini-css-extract-plugin
export default {"pagination":"PaginationComp_pagination__B-VR7","pageBtn":"PaginationComp_pageBtn__re93R","active":"PaginationComp_active__8AJb0","ellipsis":"PaginationComp_ellipsis__2l2cm"};